// Wrapper around our Typography Label
import withTypography from './withTypography'
import Label from '../components/ui/Typography/Label'

export default withTypography(Label)
